// Extraído de PeticionDetail.jsx (refactor mecánico, sin cambios funcionales)
import { useEffect, useState } from "react";
import api from "@/lib/api";

export function PortalStatusWidget({ peticionId }) {
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/peticiones/${peticionId}/portal-status`);
        setStatus(data);
      } catch (e) {
        console.warn("portal-status falló:", e?.message);
      }
    })();
  }, [peticionId]);

  if (!status || !status.portal_habilitado) return null;

  const ap = status.aprobacion_presupuesto;
  const aa = status.aprobacion_aaff_global;
  const compsApr = (status.componentes_aprobaciones || []).filter((c) => c.aprobacion_aaff);
  const compsRechazados = compsApr.filter((c) => c.aprobacion_aaff?.estado === "rechazada");
  const lastView = status.portal_last_view;
  const hoursAgo = lastView ? Math.round((Date.now() - new Date(lastView).getTime()) / 3600000) : null;

  return (
    <div className="bg-zinc-900/40 border border-zinc-800 rounded-xl p-3 mb-4" data-testid="portal-status-widget">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[11px] uppercase tracking-wider text-amber-300 font-semibold">Portal cliente</span>
          <span className="text-xs text-zinc-400 flex items-center gap-1">
            👁 <strong className="text-zinc-200">{status.portal_views_count}</strong> visita{status.portal_views_count === 1 ? "" : "s"}
          </span>
          {lastView && (
            <span className="text-xs text-zinc-500">
              · última {hoursAgo === 0 ? "hace un momento" : hoursAgo < 24 ? `hace ${hoursAgo}h` : `hace ${Math.floor(hoursAgo / 24)}d`}
            </span>
          )}
        </div>
        <button onClick={() => setOpen(!open)} data-testid="portal-status-toggle"
          className="text-[11px] text-amber-300 hover:text-amber-200">
          {open ? "Ocultar" : "Ver detalle"}
        </button>
      </div>
      <div className="flex items-center gap-3 text-xs flex-wrap">
        {status.puede_aprobar_presupuesto && <ApBadge label="Presupuesto" ap={ap} />}
        {status.puede_aprobar_aaff && <ApBadge label="AAFF global" ap={aa} />}
        {status.puede_aprobar_aaff && compsApr.length > 0 && (
          <span className={`px-2 py-0.5 rounded text-[10px] ${compsRechazados.length > 0 ? "bg-red-500/20 text-red-200" : "bg-emerald-500/20 text-emerald-200"}`}>
            Componentes: {compsApr.length - compsRechazados.length} ✓ / {compsRechazados.length} ✗
          </span>
        )}
      </div>
      {open && (
        <div className="mt-3 pt-3 border-t border-zinc-800 text-xs space-y-2">
          {ap?.comentario && (
            <div className={`p-2 rounded ${ap.estado === "rechazada" ? "bg-red-500/10 text-red-200" : "bg-emerald-500/10 text-emerald-200"}`}>
              <strong>Presupuesto · {ap.estado}</strong> · {new Date(ap.fecha).toLocaleString("es-ES")} por {ap.por}
              <div className="italic mt-0.5">💬 {ap.comentario}</div>
            </div>
          )}
          {aa?.comentario && (
            <div className={`p-2 rounded ${aa.estado === "rechazada" ? "bg-red-500/10 text-red-200" : "bg-emerald-500/10 text-emerald-200"}`}>
              <strong>AAFF global · {aa.estado}</strong> · {new Date(aa.fecha).toLocaleString("es-ES")} por {aa.por}
              <div className="italic mt-0.5">💬 {aa.comentario}</div>
            </div>
          )}
          {compsRechazados.length > 0 && (
            <div className="bg-red-500/5 border border-red-500/20 rounded p-2">
              <strong className="text-red-300">Componentes con cambios pedidos:</strong>
              <ul className="mt-1 space-y-1">
                {compsRechazados.map((c) => (
                  <li key={c.id} className="text-zinc-300">
                    · <strong>{c.nombre}</strong> — {c.aprobacion_aaff.comentario || "(sin nota)"}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {(status.portal_views || []).length > 0 && (
            <div className="text-zinc-500">
              <strong className="text-zinc-400">Últimas visitas:</strong>{" "}
              {status.portal_views.slice(-5).reverse().map((v, i) => (
                <span key={i} className="inline-block mr-2">
                  {new Date(v.visited_at).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function ApBadge({ label, ap }) {
  if (!ap) {
    return <span className="px-2 py-0.5 rounded text-[10px] bg-zinc-800 text-zinc-400">{label}: ⏳ pendiente</span>;
  }
  const ok = ap.estado === "aprobada";
  return (
    <span className={`px-2 py-0.5 rounded text-[10px] ${ok ? "bg-emerald-500/20 text-emerald-200" : "bg-red-500/20 text-red-200"}`}>
      {label}: {ok ? "✓ aprobada" : "✗ rechazada"}
    </span>
  );
}
